import React, { useState, useContext } from 'react';
import LanguageContext from '../context/LanguageContext';
import IntroductionContext from '../context/IntroductionContext';
import { getLocalizedContent, getTextDirection } from '../utils/languageUtils';

const ContactModal = ({ isOpen, onClose }) => {
    const { language } = useContext(LanguageContext);
    const { introduction } = useContext(IntroductionContext);
    const [copied, setCopied] = useState(false);
    const emailAddress = 'contact@qajarcodices.com';

    const handleCopyEmail = async () => {
        try {
            await navigator.clipboard.writeText(emailAddress);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy email: ', err);
        }
    };

    if (!isOpen) return null;

    // Get localized content
    const title = language === 'persian' ? 'تماس با ما' : 'Contact Us';
    const description = getLocalizedContent(
        introduction?.contact_us || 'For inquiries about the Qajar Codices project, please contact us at:',
        introduction?.contact_us,
        language
    );
    const copyButtonText = language === 'persian' ? 'کپی ایمیل' : 'Copy Email';
    const copiedText = language === 'persian' ? 'کپی شد!' : 'Copied!';

    const textDirection = getTextDirection(language);

    return (
        <>
            <div className="contact-modal-overlay" onClick={onClose} />
            <div className="contact-modal">
                <div className="contact-modal__header">
                    <h3 
                        className="contact-modal__title"
                        dir={textDirection}
                    >
                        {title}
                    </h3>
                    <button 
                        className="contact-modal__close" 
                        onClick={onClose}
                        aria-label="Close contact modal"
                    >
                        ×
                    </button>
                </div>
                
                <div className="contact-modal__content">
                    <p 
                        className="contact-modal__description"
                        dir={textDirection}
                    >
                        {description}
                    </p>
                    
                    <div className="contact-modal__email-section">
                        <div className="contact-modal__email-display">
                            <i className="far fa-envelope contact-modal__email-icon"></i>
                            <span className="contact-modal__email-text">{emailAddress}</span>
                        </div>
                        
                        <button 
                            className={`contact-modal__copy-button ${copied ? 'copied' : ''}`}
                            onClick={handleCopyEmail}
                        >
                            {copied ? (
                                <>
                                    <i className="fas fa-check"></i>
                                    {copiedText}
                                </>
                            ) : (
                                <>
                                    <i className="far fa-copy"></i>
                                    {copyButtonText}
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactModal; 